import { Link } from 'react-router-dom';
import { FadeUp } from './Motion.jsx';

export default function PageHero({ eyebrow, title, subtitle, primary, secondary }) {
  return (
    <section className="fullbleed page-hero">
      <div className="page-hero-inner">
        <FadeUp>
          {eyebrow && <span className="page-hero-eyebrow">{eyebrow}</span>}
          <h1 className="page-hero-title">{title}</h1>
          {subtitle && <p className="page-hero-sub">{subtitle}</p>}
        </FadeUp>

        {(primary || secondary) && (
          <FadeUp delay={0.08}>
            <div className="page-hero-cta-row">
              {primary && (
                primary.external ? (
                  <a className="page-hero-cta" href={primary.to} target="_blank" rel="noopener noreferrer">
                    {primary.label} <span aria-hidden="true">&rarr;</span>
                  </a>
                ) : (
                  <Link className="page-hero-cta" to={primary.to}>
                    {primary.label} <span aria-hidden="true">&rarr;</span>
                  </Link>
                )
              )}
              {secondary && (
                secondary.external ? (
                  <a className="page-hero-cta-secondary" href={secondary.to} target="_blank" rel="noopener noreferrer">
                    {secondary.label} <span aria-hidden="true">&rarr;</span>
                  </a>
                ) : (
                  <Link className="page-hero-cta-secondary" to={secondary.to}>
                    {secondary.label} <span aria-hidden="true">&rarr;</span>
                  </Link>
                )
              )}
            </div>
          </FadeUp>
        )}
      </div>
    </section>
  );
}